/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ExportPricesRestService } from '@gh/builder-shared-data';
import { AutocompleteItem } from '@gh/common-shared-data';
import { FilteredDataQuery, getSlicedData, SlicedDataSource } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { ExportPrices, ExportPricesLink } from './export-prices.model';

@Injectable()
export class ExportPriceBusinessService {

  constructor(private restService: ExportPricesRestService) {

  }

  getFileByFilter(from: string, to: string, type: string): Observable<ExportPricesLink> {
    const filter = {
      fromItemCode: from,
      toItemCode: to,
    };
    return type === 'excel' ? this.restService.getExcelLink(filter) : this.restService.getGoogleSpreadsheetLink(filter);
  }

  loadListOfItems(query: FilteredDataQuery<string>, from?: string): Observable<AutocompleteItem[]> {
    return this.restService.findAllAsAutocompleteDataSource({
      searchString: query.filter,
      fromItemCode: from,
    }).select(query).pipe(map$(getSlicedData));
  }

  loadPreview(from: string, to: string): SlicedDataSource<ExportPrices> {
    const filter = {
      fromItemCode: from,
      toItemCode: to,
    };
    return this.restService.findAllAsDataSource(filter);
  }
}
